/*
    EG Megamenu Image
    https://wwww.ecomgraduates.com
*/

/* Set src image width */
let imgSrcWidth = 300;
let imgDisplayWidth = 200; /* Display width */

document.querySelectorAll('.mega-menu__link').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <img src="${img}?v=1710221818&width=`+imgSrcWidth+`" style="max-width:calc(`+imgDisplayWidth+`px - 5%)">
            <div>${title}</div>
        `
        elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))'
    }
})

document.querySelectorAll('.menu-drawer__menu-item').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div>
                <img
                    src="${img}?v=1710221818&width=`+imgSrcWidth+`" style="width:`+imgDisplayWidth+`px">
                <div>
                    ${title}
                </div>
            </div>
        `
    }
})

document.querySelectorAll('.menu-drawer__close-button').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div>
                <img
                    src="${img}?v=1710221818&width=`+imgSrcWidth+`" style="width:`+imgDisplayWidth+`px">
                <div>
                    ${title}
                </div>
            </div>
        `
    }
})
